import { Placement } from '@floating-ui/react';

/**
 * The placements the dropdown is allowed to flip between.
 *
 * The panel only ever flips vertically, so this returns the caller's alignment
 * above and below the trigger. Keeping the alignment matters for a
 * right-aligned trigger: an `end`-aligned panel that fell back to `start` would
 * open away from the trigger and off the side of its container. A caller that
 * names no alignment keeps the long-standing `start` default.
 */
export function allowedPlacements(placement: Placement): Placement[] {
  const alignment = placement.split('-')[1] ?? 'start';
  return [`bottom-${alignment}` as Placement, `top-${alignment}` as Placement];
}
